// src/services/supportAdminService.js
import { apiService } from './api';

export const supportAdminService = {
  // Récupérer toutes les demandes de support
  getSupportRequests: async () => {
    try {
      const response = await apiService.get('/support/supadmin', {}, true);
      return response.data || response;
    } catch (error) {
      console.error('❌ Erreur getSupportRequests:', error);
      throw error;
    }
  },

  // Mettre à jour le statut d'une demande
  updateSupportStatus: async (requestId, status) => {
    try {
      const response = await apiService.put(`/support/supadmin/${requestId}`, { status }, true);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur updateSupportStatus:', error);
      throw error;
    }
  },

  // Supprimer une demande
  deleteSupportRequest: async (requestId) => {
    try {
      const response = await apiService.delete(`/support/supadmin/${requestId}`, {}, true);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur deleteSupportRequest:', error);
      throw error;
    }
  }
};